import { LOGIN_SUCCESS } from '../common/modules/auth';
import { loadAllContexts } from '../api/ApiManager';
import isEmpty from '../common/lib/IsEmpty';

export const UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION';
export const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION';

export const LOAD_CONTEXT_BEGIN = 'LOAD_CONTEXT_BEGIN';
export const LOAD_CONTEXT_SUCCESS = 'LOAD_CONTEXT_SUCCESS';
export const LOAD_CONTEXT_FAILURE = 'LOAD_CONTEXT_FAILURE';
export const SET_REFRESHED_APP_FLAG = 'SET_REFRESHED_APP_FLAG';
export const SET_BREADCRUMBS = 'SET_BREADCRUMBS';
export const SET_FLAGS = 'SET_FLAGS';
export const SET_AUTHENTICATED_FLAG = 'SET_AUTHENTICATED_FLAG';
export const SET_DATA_MODIFIED_WARNING = 'SET_DATA_MODIFIED_WARNING';

export const doUpdateNotification = (message, status, dismissable) => {
  return { type: UPDATE_NOTIFICATION, message, status, dismissable };
};

export const setFlags = (flags) => {
  return { type: SET_FLAGS, flags };
};

export const loadContextBegin = () => {
  return { type: LOAD_CONTEXT_BEGIN };
};

export const loadContextSuccess = (contexts) => {
  return { type: LOAD_CONTEXT_SUCCESS, contexts };
};

export const loadContextFailure = () => {
  return { type: LOAD_CONTEXT_FAILURE };
};

export const setAppRefreshedFlag = (flag) => {
  return { type: SET_REFRESHED_APP_FLAG, flag };
};

export const hideNotification = () => {
  return { type: 'HIDE_NOTIFICATION' };
};
export const updateNotification = (message, status, dismissable) => {
  return (dispatch) => {
    dispatch(doUpdateNotification(message, status, dismissable));
    setTimeout(() => {
      !dismissable && dispatch({ type: 'HIDE_NOTIFICATION' });
    }, 8000);
  };
};
export const setDataModifiedWarning = (setting) => {
  return { type: SET_DATA_MODIFIED_WARNING, setting };
};
////////////////
// ASYNC
////////////////

export const loadContexts = (domain) => {
  return (dispatch) => {
    dispatch(loadContextBegin());
    loadAllContexts(domain)
      .then((response) => {
        dispatch(loadContextSuccess(response.data.Contexts));
      })
      .catch((e) => {
        dispatch(loadContextFailure(e.response));
      });
  };
};

export const setAuthenticated = (authenticated) => {
  return { type: SET_AUTHENTICATED_FLAG, authenticated };
};

const ACTION_HANDLERS = {
  [LOGIN_SUCCESS]: (state, action) => {
    localStorage.setItem('axsLDKey', action.user.Meta.LDKey);
    state.contexts.length > 0 &&
      localStorage.setItem('contexts', JSON.stringify(state.contexts));
    return Object.assign({}, state, {
      UserName: action.user.UserName,
      contextId: action.user.Meta.Context,
      contexts: state.contexts,
      LDKey: action.user.Meta.LDKey,
    });
  },
  [UPDATE_NOTIFICATION]: (state, action) => {
    return Object.assign({}, state, {
      notification: {
        message: action.message,
        status: action.status,
        dismissable: action.dismissable,
      },
    });
  },
  [HIDE_NOTIFICATION]: (state) => {
    return Object.assign({}, state, { notification: {} });
  },
  [LOAD_CONTEXT_SUCCESS]: (state, action) => {
    return Object.assign({}, state, {
      contexts:
        action.contexts.length > 0 &&
        action.contexts.sort((a, b) =>
          a.Description.toLowerCase() > b.Description.toLowerCase() ? 1 : -1
        ),
    });
  },
  [LOAD_CONTEXT_FAILURE]: (state) => {
    return Object.assign({}, state);
  },
  [SET_FLAGS]: (state, { flags }) => {
    return Object.assign({}, state, { flags });
  },
  [SET_REFRESHED_APP_FLAG]: (state, { flag }) => {
    return Object.assign({}, state, { appRefreshed: flag });
  },
  [SET_BREADCRUMBS]: (state, { breadcrumbs }) => {
    return Object.assign({}, state, { breadcrumbs });
  },
  [SET_AUTHENTICATED_FLAG]: (state, { authenticated }) => {
    return Object.assign({}, state, { authenticated });
  },
  [SET_DATA_MODIFIED_WARNING]: (state, { setting }) => {
    return {
      ...state,
      dataConcurrency: {
        ...state.dataConcurrency,
        dataModifiedWarning: setting,
      },
    };
  },
};

const initialState = {
  contextId: localStorage.getItem('axsContextId'),
  contexts: JSON.parse(localStorage.getItem('contexts')) || [],
  flags: {},
  LDKey: localStorage.getItem('axsLDKey'),
  notification: {},
  UserName: localStorage.getItem('axsUserName') || null,
  authenticated: !isEmpty(localStorage.getItem('axsUserName')),
  appRefreshed: false,
  dataConcurrency: {
    dataModifiedWarning: false,
  },
};

export default function appReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/app.js